import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { AuthSlice } from './slices/auth';
import { DBSlice } from './slices/db';
import { HomeReadingSlice } from './slices/homeReadings';
import { RelayReadingSlice } from './slices/relayReadings';
import { UserEnrolledThingSlice } from './slices/userEnrolledThings';
import { UserHomesSlice } from './slices/userHomes';
import { HomeHistorySlice } from './slices/homeHistory';
import { HomeLEDSlice } from './slices/homeLED';
import { AddressListSlice } from './slices/addressList';



const AppReducer = combineReducers({
    db: DBSlice.reducer,
    auth: AuthSlice.reducer,
    userHomes: UserHomesSlice.reducer,
    userEnrolledThings: UserEnrolledThingSlice.reducer,
    homeReading: HomeReadingSlice.reducer,
    homeLED : HomeLEDSlice.reducer,
    relayReading: RelayReadingSlice.reducer,
    homeHistory: HomeHistorySlice.reducer,
    addressList: AddressListSlice.reducer,
});

const overriddenReducer = (state,action)=>{
    if(action.type === 'reset'){
        return AppReducer(undefined,action);
    }
    return AppReducer(state,action);
}

const AppActions = {
    db: DBSlice.actions,
    auth: AuthSlice.actions,
    userHomes: UserHomesSlice.actions,
    userEnrolledThings: UserEnrolledThingSlice.actions,
    homeReading: HomeReadingSlice.actions,
    relayReading: RelayReadingSlice.actions,
    homeHistory: HomeHistorySlice.actions,
    homeLED : HomeLEDSlice.actions,
    addressList: AddressListSlice.actions
}

const AppStore = configureStore({
    reducer: overriddenReducer,
});


export { AppStore, AppActions };